import React from 'react';
import classNames from 'classnames';
import LoadingSpinner from './loading-spinner';
import TellyChannelLogo from '../../images/app-store-icon.png';

interface AvatarProps {
	channelName: string;
	logoWhite: string;
	loading?: boolean;
	size?: string
}

function getThumb(passedChannelName: string, passedLogoWhite: string) {
	if (passedLogoWhite) {
		const url = passedLogoWhite;

		return (
			<img className="avatar" src={url} alt={passedChannelName || ''} />
		);
	}
	return (
			<div className="telly-channel-bubble-container">
				<div className="telly-channel-bubble">
					<img src={TellyChannelLogo} alt='telly'></img>
				</div>
			</div>
	);
}

export default function ChannelAvatar(props: AvatarProps) {
	const {
		channelName,
		logoWhite,
		loading = false,
		size = 'normal',
	} = props;

	return (
		<div className={classNames('avatar-container', size)} style={{ border: 'none' }}>
			{getThumb(channelName, logoWhite)}
			{loading && (
				<div className="loading-background">
					<LoadingSpinner
						height={20}
						width={20}
						stroke={10}
					/>
				</div>
			)}
		</div>
	);
}
